import { render, staticRenderFns } from "./add.vue?vue&type=template&id=7c358343"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c358343')) {
      api.createRecord('7c358343', component.options)
    } else {
      api.reload('7c358343', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=7c358343", function () {
      api.rerender('7c358343', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/apply/add.vue"
export default component.exports